export default __webpack_public_path__ + "static/media/home-banner-mobile.1eb652a5.png";